const ResetModal = function () {
  this.addStore.resetForm()
  this.addStore.loader.hideLoader()
  this.addStore.submitButton.setEnabled()
}

export default ResetModal
